import { Context } from "../EditorContext";
import { useCallback, useContext, useEffect } from "react";
import { useUpdate } from "ahooks";
import CloseButton from "../CloseButton/CloseButton";

const getCornerComponents = ({ position, size, closeBtnSize, closeButtonDistance, content, padding }) => {
  const innerHeight = Math.sqrt((size * size) / 2);
  const innerWidth = Math.sqrt(size * size * 2);

  const distance = innerHeight - closeButtonDistance;

  const closeBtnOffset = Math.sqrt((distance * distance) / 2);
  const closeBtnInnerPost = -closeBtnSize / 2;

  if (position === "top-left") {
    return (
      <div
        style={{ width: size, height: size }}
        className={`rip-mm-teaser rip-mm-teaser-corner top-left animate__animated animate__fadeInTopLeft`}
      >
        <div
          style={{
            position: "absolute",
            bottom: closeBtnOffset,
            right: closeBtnOffset,
          }}
        >
          <CloseButton top={closeBtnInnerPost} right={closeBtnInnerPost} />
        </div>
        <div
          style={{
            width: innerWidth,
            height: innerHeight,
            background: "white",
            transform: "rotate(-45deg)",
            transformOrigin: "left top",
            position: "relative",
            display: "flex",
            top: size / 2,
            left: -(size / 2),
            boxShadow: "0 0 5px #ccc",
            flexDirection: "column-reverse",
            alignItems: "center",
          }}
        >
          <div style={{padding}} dangerouslySetInnerHTML={{__html: content}} />
        </div>
      </div>
    );
  } else if (position === "top-right") {
    return (
      <div
        style={{ width: size, height: size }}
        className={`rip-mm-teaser rip-mm-teaser-corner top-right animate__animated animate__fadeInTopRight`}
      >
        <div
          style={{
            position: "absolute",
            left: closeBtnOffset,
            bottom: closeBtnOffset,
          }}
        >
          <CloseButton top={closeBtnInnerPost} right={closeBtnInnerPost} />
        </div>
        <div
          style={{
            display: "flex",
            width: innerWidth,
            height: innerHeight,
            background: "white",
            transform: "rotate(45deg)",
            transformOrigin: "left top",
            position: "relative",
            top: -(size / 2),
            left: size / 2,
            boxShadow: "0 0 5px #ccc",
            flexDirection: "column-reverse",
            alignItems: "center",
          }}
        >
          <div style={{padding}} dangerouslySetInnerHTML={{__html: content}} />
        </div>
      </div>
    );
  } else if (position === "bottom-left") {
    return (
      <div
        style={{ width: size, height: size }}
        className={`rip-mm-teaser rip-mm-teaser-corner bottom-left animate__animated animate__fadeInBottomLeft`}
      >
        <div
          style={{
            position: "absolute",
            top: closeBtnOffset,
            right: closeBtnOffset,
          }}
        >
          <CloseButton top={closeBtnInnerPost} right={closeBtnInnerPost} />
        </div>
        <div
          style={{
            width: innerWidth,
            height: innerHeight,
            background: "white",
            transform: "rotate(45deg)",
            transformOrigin: "left top",
            position: "relative",
            boxShadow: "0 0 5px #ccc",
          }}
        >
          <div style={{padding}} dangerouslySetInnerHTML={{__html: content}} />
        </div>
      </div>
    );
  } else if (position === "bottom-right") {
    return (
      <div
        style={{ width: size, height: size }}
        className={`rip-mm-teaser rip-mm-teaser-corner bottom-right animate__animated animate__fadeInBottomRight`}
      >
        <div
          style={{
            position: "absolute",
            top: closeBtnOffset,
            left: closeBtnOffset,
          }}
        >
          <CloseButton top={closeBtnInnerPost} right={closeBtnInnerPost} />
        </div>
        <div
          style={{
            width: innerWidth,
            height: innerHeight,
            background: "white",
            transform: "rotate(-45deg)",
            transformOrigin: "left top",
            position: "relative",
            top: size,
            boxShadow: "0 0 5px #ccc",
          }}
        >
          <div style={{padding}} dangerouslySetInnerHTML={{__html: content}} />
        </div>
      </div>
    );
  }
};

export default () => {
  const { state, shareRefs } = useContext(Context);

  const { root } = state;

  const {
    shape,
    position,
    content,
    size,
    closeButtonDistance,
    padding,
  } = root.extraComponents.teaser.data;

  const update = useUpdate();

  const updateTeaserContent = useCallback(
    (data = {}) => {
      Object.assign(root.extraComponents.teaser.data, data);
      update();
    },
    [root.extraComponents.teaser, update]
  );

  useEffect(() => {
    shareRefs.updateTeaserContent = updateTeaserContent;
  }, []);

  const closeBtnSize = root.extraComponents.closeButton.data.size;

  return (
    <div className="rip-mm-teaser-wrapper">
      <iframe
        src="https://www.radicasys.com"
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 1,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
        frameBorder={0}
      />
      <div
        style={{
          position: "absolute",
          zIndex: 2,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: "rgba(0, 0, 0, .2)",
        }}
      />
      {getCornerComponents({ size, position, closeBtnSize, closeButtonDistance, content, padding })}
    </div>
  );
};
